export default "__VITE_ASSET__DgglTl4h__"